module.exports = __webpack_public_path__ + "img/newmoon.2f9447fb.png";